"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantDownloadOrderState = void 0;
var ParticipantDownloadOrderState;
(function (ParticipantDownloadOrderState) {
    ParticipantDownloadOrderState["Paid"] = "paid";
})(ParticipantDownloadOrderState = exports.ParticipantDownloadOrderState || (exports.ParticipantDownloadOrderState = {}));
//# sourceMappingURL=participant-download-order-state.js.map